import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useMarketPricing } from "../../store/useMarketPricing";
import {
  CumulativeUsersConversion,
  DroppieRevenueGraph,
  GeneralFilters,
  ParcelsRevenue,
  ParcelsVolume,
  RevenuePerCustomerChart,
  StatiegeldVolumesGraphsChart,
  StreamingVolumeChart,
  TotalDroppieRevenueChart,
  UserFilters,
} from "../../components";
import { ParcelRevenue } from "../../components/charts/ParcelRevenue.chart";
import { StatieRevenue } from "../../components/charts/StatieRevenue.chart";
import { UserChurn } from "../../components/charts/UserChurn.chart";
import { MaterialConversion } from "../../components/charts/MaterialConversion.chart";
import { useDropLocations } from "../../store/useDropLocations";

function Graveyard() {
  const [filterType] = useState<"location" | "city">("location");
  const [filterPlaces] = useState<string[]>([]);
  /** Hooks */
  const { getAllMarketPrices } = useMarketPricing();
  /** State */
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [period, setPeriod] = useState<
    "Daily" | "Weekly" | "LastTwelweMonths" | "Monthly" | "Yearly"
  >("LastTwelweMonths");
  const [weeklyRange, setWeeklyRange] = useState(new Date());
  const [monthRange, setMonthRange] = useState(new Date());
  const [yearRange, setYearRange] = useState(new Date());

  /** Hooks */
  const { getDropLocations } = useDropLocations();
  /** State */
  const [period2, setPeriod2] = useState<
    "all" | "yearly" | "quarterly" | "monthly" | "weekly"
  >("all");
  const [year, setYear] = useState<number>(dayjs().year());
  // @ts-ignore
  const [quarter, setQuarter] = useState<"Q1" | "Q2" | "Q3" | "Q4">(
    `Q${dayjs().quarter()}` as "Q1" | "Q2" | "Q3" | "Q4"
  );
  const [month, setMonth] = useState<number>(dayjs().month());
  const [week, setWeek] = useState<Date>(new Date());
  const [selectedStores, setSelectedStores] = useState<string[]>([]);

  /** Effects */
  useEffect(() => {
    getDropLocations();
    getAllMarketPrices();
  }, [getDropLocations, getAllMarketPrices]);

  return (
    <>
      <div className="flex flex-col w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Graveyard
        </h1>

        <GeneralFilters
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          period={period}
          setPeriod={setPeriod}
          weeklyRange={weeklyRange}
          setWeeklyRange={setWeeklyRange}
          monthRange={monthRange}
          setMonthRange={setMonthRange}
          yearRange={yearRange}
          setYearRange={setYearRange}
        />

        {/* Graphs */}
        {/* Revenues */}
        <div className="flex gap-1">
          <DroppieRevenueGraph
            periodProp={period}
            selectedFiltersProp={selectedFilters}
            weeklyRangeProp={weeklyRange}
            monthRangeProp={monthRange}
            yearRangeProp={yearRange}
            className="w-full sm:w-2/3"
          />

          <TotalDroppieRevenueChart
            periodProp={period}
            monthRangeProp={monthRange}
            yearRangeProp={yearRange}
            className="w-full sm:w-1/3 sm:ml-2"
          />
        </div>

        {/* Volumes */}
        <StreamingVolumeChart
          periodProp={period}
          weeklyRangeProp={weeklyRange}
          monthRangeProp={monthRange}
          yearRangeProp={yearRange}
          selectedFiltersProp={selectedFilters}
        />

        {/* Bunu aktiv edeceyik  */}
        <RevenuePerCustomerChart
          periodProp={period}
          selectedFiltersProp={selectedFilters}
          weeklyRangeProp={weeklyRange}
          monthRangeProp={monthRange}
          yearRangeProp={yearRange}
        />

        <ParcelsVolume periodProp={period} />
        <ParcelsRevenue periodProp={period} />
        <ParcelRevenue />
        <StatiegeldVolumesGraphsChart periodProp={period} />
        <StatieRevenue filterType={filterType} filterPlaces={filterPlaces} />

        <UserChurn />
        <MaterialConversion />

        <UserFilters
          period={period2}
          year={year}
          quarter={quarter}
          month={month}
          week={week}
          selectedFilters={selectedFilters}
          selectedStores={selectedStores}
          setPeriod={setPeriod2}
          setYear={setYear}
          setQuarter={setQuarter}
          setMonth={setMonth}
          setWeek={setWeek}
          setSelectedFilters={setSelectedFilters}
          setSelectedStores={setSelectedStores}
        />
        <CumulativeUsersConversion
          periodProp={period2}
          yearProp={year}
          quarterProp={quarter}
          monthProp={month}
          weekProp={week}
          selectedFiltersProp={selectedFilters}
          selectedStoresProp={selectedStores}
        />
        <MaterialConversion />
      </div>
    </>
  );
}

export default withProtectedRoute(Graveyard);
